import React from 'react';
import { Box, Typography } from '@mui/material';
import SignalWifiOffIcon from '@mui/icons-material/SignalWifiOff';

const ERROR_COLOR = '#ef4444';

// Shown on every step while the phone has no usable signal. It used to offer "Abort this
// installation", which can't work offline: Confirm did nothing until signal came back, or
// the page went black (stress test 22/10, N9). Aborting stays on the step's own Abort,
// which now says when there's no signal.
const SignalBanner = () => (
  <Box sx={{
    mx: 2,
    mt: 1,
    mb: 0.5,
    borderRadius: '10px',
    border: `1px solid ${ERROR_COLOR}80`,
    backgroundColor: `${ERROR_COLOR}22`,
    p: '12px 14px 10px',
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: '5px' }}>
      <SignalWifiOffIcon sx={{ color: ERROR_COLOR, fontSize: '1.1rem', flexShrink: 0 }} />
      <Typography sx={{ color: ERROR_COLOR, fontWeight: 700, fontSize: '0.88rem' }}>
        No signal
      </Typography>
    </Box>
    <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.80rem', lineHeight: 1.55 }}>
      You need signal to continue. Nothing can be saved until you're back online.
    </Typography>
  </Box>
);

export default SignalBanner;
